import { createContext, useContext } from 'react'

export const LoggedInUserFacilityPermissionsContext = createContext<string[]>([])
export const useLoggedInUserFacilityPermissions = () =>
  useContext(LoggedInUserFacilityPermissionsContext)
